<template>
  <div class="user_device-bd">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <!-- 配置表格列 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input :placeholder="$t('base_user_device.jshModemSNjqmc')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="$refs.container"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('base_user_device.chan_pin_xing_hao')">
          <custom-select url="productCodeSelectList" v-model="formSearch.productCode" :props="{ label: 'productCode', value: 'productCode' }" :placeholder="$t('Common.com_please_select')" width="100%"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('base_user_device.zu_zhi_ming_cheng')">
          <custom-select
            style="display: inline-block; width: 98px; margin-right: 2px"
            @clear="formSearch.orgName = ''"
            v-model="formSearch.orgType"
            code="bas_org_type"
            :props="{ label: 'name', value: 'value' }"
            :placeholder="$t('base_user_device.zu_zhi_lei_xing')"
            width="100%"
          ></custom-select>
          <el-input :disabled="!formSearch.orgType" v-model="formSearch.orgName" style="width:calc(100% - 100px)"></el-input>
        </el-form-item>
        <el-form-item :label="$t('base_user_device.xiang_mu_ming_cheng')">
          <el-input v-model="formSearch.locationName" style="width:100%;"></el-input>
        </el-form-item>
        <el-form-item :label="$t('base_user_device.he_tong_bian_hao')">
          <el-input v-model="formSearch.contractNo" style="width:100%;"></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table :index="true" tableCode="user_devices" :data="deviceList" @column="setColumn" @filter="filterChange" @sort="sortChange"></custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';

export default {
  mixins: [resetFormSearchMixins],
  components: {
  },
  props: {
    userId: {
      type: [String, Number, Boolean],
      default: ''
    },
    orgId: [String, Number]
  },
  data() {
    return {
      formSearch: {
        userId: '',
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 20,
        pageNum: 1,
        productCode: '',
        orgType: '',
        orgName: '',
        locationName: '',
        contractNo: ''
      },
      deviceList: [],
      totalRows: 0,
      userBizType: ''
    };
  },
  watch: {
    userId: function () {
      this.resetFormSearch = JSON.stringify(this.formSearch);
      this.getUserDevice();
    }
  },
  mounted: function () {
    this.getFuncView('/company/user');
    this.getUserDevice();
    const userInfo = this.$store.state.userInfo || {};
    this.userBizType = userInfo.bizType;
  },
  methods: {
    // 用户设备
    getUserDevice: function () {
      if (!this.userId) {
        this.deviceList = [];
        this.totalRows = 0;
        return;
      }
      this.formSearch.userId = this.userId;
      this.$getJSON(apis.DevicePage, this.formSearch).then((res) => {
        this.deviceList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getUserDevice();
    }
  }
};
</script>
